/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailContentResultDto
 */
export interface EmailContentResultDto {
    /**
     * 
     * @type {string}
     * @memberof EmailContentResultDto
     */
    subject?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailContentResultDto
     */
    htmlContent?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EmailContentResultDto
     */
    attachmentCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EmailContentResultDto
     */
    plainTextContent?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof EmailContentResultDto
     */
    date?: Date;
    /**
     * 
     * @type {string}
     * @memberof EmailContentResultDto
     */
    email?: string | null;
}

/**
 * Check if a given object implements the EmailContentResultDto interface.
 */
export function instanceOfEmailContentResultDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EmailContentResultDtoFromJSON(json: any): EmailContentResultDto {
    return EmailContentResultDtoFromJSONTyped(json, false);
}

export function EmailContentResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailContentResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subject': !exists(json, 'subject') ? undefined : json['subject'],
        'htmlContent': !exists(json, 'htmlContent') ? undefined : json['htmlContent'],
        'attachmentCount': !exists(json, 'attachmentCount') ? undefined : json['attachmentCount'],
        'plainTextContent': !exists(json, 'plainTextContent') ? undefined : json['plainTextContent'],
        'date': !exists(json, 'date') ? undefined : (new Date(json['date'])),
        'email': !exists(json, 'email') ? undefined : json['email'],
    };
}

export function EmailContentResultDtoToJSON(value?: EmailContentResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subject': value.subject,
        'htmlContent': value.htmlContent,
        'attachmentCount': value.attachmentCount,
        'plainTextContent': value.plainTextContent,
        'date': value.date === undefined ? undefined : (value.date.toISOString()),
        'email': value.email,
    };
}

